/**
 * Created by razial on 20.11.2023
 */

Telly.PRIZES.dragonia3 = [
    [{
        units: [
            { currentType: "drresource", stage: 0 },
            { currentType: "drhero", stage: 0 },
            { code: "worker", stage: 0 }
        ]
    }],

    [{
        units: [
            { currentType: "drresource", stage: 1 },
            { currentType: "drhero", stage: 1 },
            { code: "worker", stage: 1 },
            { code: "drmagicplant", stage: 1 }
        ]
    }],

    [{
        units: [
            { currentType: "drresource", stage: 2 },
            { currentType: "drhero", stage: 2 },
            { code: "worker", stage: 2 },
            { code: "drmagicplant", stage: 1 },
            { code: "crystal", stage: 1 }
        ]
    }]
];

MissionTree.PRIZES.dragonia3 = cleverapps.clone(MissionTree.PRIZES.universal, true);

Ruins.TIERS.dragonia3 = {
    cheap: {
        soft: 59,
        rewards: [
            { code: "drfreechest", stage: 0, amount: 1 },
            { code: "worker", stage: 0, amount: 1 },
            { code: "crystal", stage: 0, amount: 1 }
        ]
    },
    costly: {
        hard: 249,
        rewards: [
            { code: "drshopchest", stage: 1, amount: 1 },
            { code: "crystal", stage: 3, amount: 1 },
            { code: "drmagicplant", stage: 5, amount: 1 },
            { code: "worker", stage: 4, amount: 1 }
        ]
    }
};

GrowingsPlanner.CONFIG.dragonia3 = cleverapps.clone(GrowingsPlanner.CONFIG.universal, true);

AchievementsConfig.registerExpedition("dragonia3", {
    force: Forces.LANDMARK_DONOR_SLOT2,
    target: { code: "drcustomermain0", stage: 0 },
    donors: ["drcustomermain0", "drcustomermain1", "drcustomermain2", "drcustomermain3"]
});

FieldComponent.RECIPES.dragonia3 = [{
    prize: { code: "drproduct0a", stage: 0 },
    duration: cleverapps.parseInterval("15 minute")
}, {
    prize: { code: "drproduct0b", stage: 0 },
    duration: cleverapps.parseInterval("15 minute"),
    opened: true
}];

CustomerRecipes.dragonia3 = {
    drproducer1a_0: [
        {
            ingredients: [{
                code: "drproduct0a",
                stage: 0,
                amount: 3
            }],
            order: [{
                code: "drproduct1a",
                stage: 0,
                amount: 1
            }]
        }, // 1
        {
            opened: true,
            ingredients: [{
                code: "drproduct0b",
                stage: 0,
                amount: 3
            }],
            order: [{
                code: "drproduct1a",
                stage: 0,
                amount: 1
            }]
        }, // 2
        {
            opened: true,
            ingredients: [{
                code: "drproduct0a",
                stage: 0,
                amount: 1
            }, {
                code: "drproduct0b",
                stage: 0,
                amount: 2
            }],
            order: [{
                code: "drproduct1a",
                stage: 0,
                amount: 1
            }]
        }, // 3
        {
            opened: true,
            ingredients: [{
                code: "drproduct0a",
                stage: 0,
                amount: 2
            }, {
                code: "drproduct0b",
                stage: 0,
                amount: 1
            }],
            order: [{
                code: "drproduct1a",
                stage: 0,
                amount: 1
            }]
        }// 4
    ],

    drproducer1b_0: [
        {
            opened: true,
            ingredients: [{
                code: "drproduct0a",
                stage: 0,
                amount: 3
            }],
            order: [{
                code: "drproduct1b",
                stage: 0,
                amount: 1
            }]
        }, // 1
        {
            opened: true,
            ingredients: [{
                code: "drproduct0b",
                stage: 0,
                amount: 3
            }],
            order: [{
                code: "drproduct1b",
                stage: 0,
                amount: 1
            }]
        }, // 2
        {
            opened: true,
            ingredients: [{
                code: "drproduct0a",
                stage: 0,
                amount: 1
            }, {
                code: "drproduct0b",
                stage: 0,
                amount: 2
            }],
            order: [{
                code: "drproduct1b",
                stage: 0,
                amount: 1
            }]
        }, // 3
        {
            opened: true,
            ingredients: [{
                code: "drproduct0a",
                stage: 0,
                amount: 2
            }, {
                code: "drproduct0b",
                stage: 0,
                amount: 1
            }],
            order: [{
                code: "drproduct1b",
                stage: 0,
                amount: 1
            }]
        }// 4
    ],

    drproducer2a_0: [
        {
            ingredients: [{
                code: "drproduct1a",
                stage: 0,
                amount: 3
            }],
            order: [{
                code: "drproduct2a",
                stage: 0,
                amount: 1
            }]
        }, // 1
        {
            ingredients: [{
                code: "drproduct1b",
                stage: 0,
                amount: 3
            }],
            order: [{
                code: "drproduct2a",
                stage: 0,
                amount: 1
            }]
        }, // 2
        {
            ingredients: [{
                code: "drproduct1a",
                stage: 0,
                amount: 1
            }, {
                code: "drproduct1b",
                stage: 0,
                amount: 2
            }],
            order: [{
                code: "drproduct2a",
                stage: 0,
                amount: 1
            }]
        }, // 3
        {
            ingredients: [{
                code: "drproduct1a",
                stage: 0,
                amount: 2
            }, {
                code: "drproduct1b",
                stage: 0,
                amount: 1
            }],
            order: [{
                code: "drproduct2a",
                stage: 0,
                amount: 1
            }]
        }// 4
    ],

    drproducer2b_0: [
        {
            ingredients: [{
                code: "drproduct1a",
                stage: 0,
                amount: 3
            }],
            order: [{
                code: "drproduct2a",
                stage: 0,
                amount: 1
            }]
        }, // 1
        {
            ingredients: [{
                code: "drproduct1b",
                stage: 0,
                amount: 3
            }],
            order: [{
                code: "drproduct2a",
                stage: 0,
                amount: 1
            }]
        }, // 2
        {
            ingredients: [{
                code: "drproduct1a",
                stage: 0,
                amount: 1
            }, {
                code: "drproduct1b",
                stage: 0,
                amount: 2
            }],
            order: [{
                code: "drproduct2a",
                stage: 0,
                amount: 1
            }]
        }, // 3
        {
            ingredients: [{
                code: "drproduct1a",
                stage: 0,
                amount: 2
            }, {
                code: "drproduct1b",
                stage: 0,
                amount: 1
            }],
            order: [{
                code: "drproduct2a",
                stage: 0,
                amount: 1
            }]
        }// 4
    ],

    drproducertrash_0: [{
        ingredients: [{
            code: "drproduct2a",
            stage: 0,
            amount: 3
        }],
        order: [{
            code: "worker",
            stage: 1,
            amount: 1
        }, {
            code: "energy",
            stage: 1,
            amount: 1
        }]
    }],

    drcustomermain0_0: [{
        ingredients: [{
            code: "drproduct2a",
            stage: 0,
            amount: 3
        }],
        order: [{
            code: "worker",
            stage: 2,
            amount: 1
        }, {
            code: "crystal",
            stage: 1,
            amount: 1
        }, {
            code: "energy",
            stage: 1,
            amount: 1
        }]
    }],

    drcustomerbridge1_0: [{
        ingredients: [{
            code: "drproduct1a",
            stage: 0,
            amount: 3
        }],
        order: [{
            code: "drgrowing",
            stage: 1,
            amount: 3
        }]
    }]
};

CustomerRecipes.dragonia3.drcustomermain1_0 = CustomerRecipes.dragonia3.drcustomermain0_0;
CustomerRecipes.dragonia3.drcustomermain2_0 = CustomerRecipes.dragonia3.drcustomermain0_0;
CustomerRecipes.dragonia3.drcustomermain3_0 = CustomerRecipes.dragonia3.drcustomermain0_0;

const Dragonia3SourceMine = {
    prize: function (level, unit) {
        let amounts = [[1], [1, 1], [1, 1, 1]];
        const chestStage = [0, 0, 0];

        switch (unit.code) {
            case "drsledsource":
                amounts = [[1], [1, 2], [1, 2, 2, PseudoRandom.GET().random(2, 3)]];
                break;

            case "drcastlesource":
                amounts = [[2], [2, 3], [1, 2, 3, PseudoRandom.GET().random(3, 4)]];
                break;
        }

        let chestCode = `${unit.getResource()}chest`;
        if (!Families[chestCode] || !Families[chestCode].expeditions.includes(cleverapps.meta.getSelectedLocation().locationId)) {
            chestCode = "drfreechest";
        }

        if (level === unit.getData().mineable.tasks.length - 1) {
            return [{
                units: [{ code: chestCode, stage: chestStage[unit.stage] }]
            }, {
                amount: [1, 3],
                units: [{ code: "drsnail", stage: 0 }]
            }];
        }

        return [{
            amount: amounts[unit.stage][level],
            units: [{ code: unit.getResource(), stage: 0 }]
        }, {
            amount: [1, 3],
            units: [{ code: "drsnail", stage: 0 }]
        }];
    }
};

Mines.drsource = Dragonia3SourceMine.prize;
Mines.drgrowing = WandsGrowing.prize;

UnitsLibrary.CODES_BY_TAB.dragonia3 = [
    ["drhero", "drrubyhero"],
    ["drresource"],
    ["drfruit"],
    ["drgrowing", "drsource"],
    ["drchest"],
    ["worker", "coins", "crystal", "drmagicplant", "snailfeast", "snailhouse"]
];

UnitsLibrary.EXPEDITION_PREFIXES.dragonia3 = "dr";

ShopWindow.TABS.UNITS_EXPEDITION_DRAGONIA3 = 25;

UnitsShop.SHOPS.dragonia3 = [{
    tab: ShopWindow.TABS.UNITS_EXPEDITION_DRAGONIA3,
    unit: { code: "dr2shop", stage: 0 }
}];

UnitsShop.PRODUCTS[ShopWindow.TABS.UNITS_EXPEDITION_DRAGONIA3] = {
    refreshTimeout: "24 hours",
    refreshPrice: 199,

    default: [{
        unit: {
            code: "drfreechest",
            stage: 0,
            amount: 1
        },
        type: Product.TYPE_FREE,
        left: 1
    }, {
        unit: {
            code: "drsack",
            stage: 0,
            amount: 2
        },
        type: Product.TYPE_FREE,
        left: 1
    }, {
        unit: {
            code: "drsack",
            stage: 2,
            amount: 1
        },
        price: 149,
        type: Product.TYPE_HARD,
        left: 3
    }, {
        unit: {
            code: "drshopchest",
            stage: 0,
            amount: 1
        },
        price: 49,
        type: Product.TYPE_HARD,
        left: 10
    }, {
        unit: {
            code: "drshopchest",
            stage: 1,
            amount: 1
        },
        price: 129,
        type: Product.TYPE_HARD,
        left: 15
    }, {
        unit: {
            code: "drshopchest",
            stage: 2,
            amount: 1
        },
        price: 319,
        type: Product.TYPE_HARD,
        left: 30
    }, {
        unit: {
            code: "crystal",
            stage: 3,
            amount: 1
        },
        price: 119,
        type: Product.TYPE_HARD,
        left: 5
    }, {
        unit: {
            code: "worker",
            stage: 4,
            amount: 1
        },
        price: 79,
        type: Product.TYPE_HARD,
        left: 5
    }],

    line_template: [{
        unit: {
            stage: 0,
            amount: 1
        },
        codes: "field",
        left: 1,
        price: 199,
        type: Product.TYPE_HARD
    }]
};

PixelsPlanner.AVAILABLE.dragonia3 = {
    fog: "fog3"
};

PixelsSwarm.DRAGONIA3 = "dragonia3";

PixelsSwarmConfig[PixelsSwarm.DRAGONIA3] = {
    pages: ["dragonia3"],
    reward: [{
        units: [
            { code: "drmagicplant", stage: 0 },
            { code: "drgrowing", stage: 0 },
            { code: "worker", stage: 0 },
            { code: "drfruit", stage: 0 }
        ]
    }]
};

PixelsSwarmConfig[PixelsSwarm.ADS].pages.push("dragonia3");

cleverapps.styles.PixelView[PixelsSwarm.DRAGONIA3] = cleverapps.overrideStyles(cleverapps.styles.PixelViewTemplate, {}, true);